// extracted by mini-css-extract-plugin
module.exports = {"SectionBanner":"AwardView_SectionBanner__1HXwZ","Wrapper":"AwardView_Wrapper__14a57","Text":"AwardView_Text__2-fci","Winner":"AwardView_Winner__33zjf"};